jQuery(document).ready(function ($) {
    const block = $('.faq-img-block');
    if (!block.get(0)) return;

    block.find('[data-accordeon-title]').click((e) => {
        e.preventDefault();
        const title = $(e.target).closest('[data-accordeon-title]');
        $(title).siblings('[data-accordeon-content]').slideToggle();
        $(e.target).closest('[data-accordeon-item]').toggleClass('active');
    });
});
